import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";
import { useSeo } from "@/hooks/useSeo";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import { BusinessCard } from "@/components/BusinessCard";
import { CardsSkeleton } from "@/components/CardsSkeleton";
import { Button } from "@/components/ui/button";

export default function FavouritesPage() {
  useSeo("My Favourites | OyeBest", "Your saved favourite businesses on OyeBest.");
  const navigate = useNavigate();
  const { customer, favIds, loginWithGoogle } = useCustomerAuth();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (customer === false) { setLoading(false); return; }
    if (!customer) return;
    setLoading(true);
    api.get("/favourites").then((r) => setList(r.data)).finally(() => setLoading(false));
  }, [customer, favIds.length]);

  if (customer === false) {
    return (
      <div className="max-w-md mx-auto px-4 py-24 text-center">
        <Heart className="w-10 h-10 text-primary mx-auto mb-4" />
        <h1 className="font-display text-2xl font-bold">Login to see your favourites</h1>
        <p className="text-muted-foreground mt-2">Save your favourite places and access them anytime.</p>
        <Button className="mt-6 rounded-full" onClick={loginWithGoogle} data-testid="fav-login-btn">Continue with Google</Button>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">My Favourites</h1>
      <p className="text-muted-foreground mt-1 mb-8">Your saved businesses</p>
      {loading ? <CardsSkeleton /> : list.length === 0 ? (
        <div className="text-center py-20 rounded-2xl bg-secondary/50 border border-border">
          <Heart className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
          <h3 className="font-display text-xl font-bold">No favourites yet</h3>
          <p className="text-muted-foreground mt-1">Tap the heart on any business to save it here.</p>
          <Button className="mt-5 rounded-full" onClick={() => navigate("/")}>Explore Businesses</Button>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {list.map((b, i) => <BusinessCard key={b.id} business={b} index={i} />)}
        </div>
      )}
    </div>
  );
}
